/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRiskExclusionRequestBody,
  UpdateRiskExclusionRequestBody$Outbound,
  UpdateRiskExclusionRequestBody$outboundSchema,
} from "../components/updateriskexclusionrequestbody.js";

export type UpdateRiskExclusionSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateRiskExclusionSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateRiskExclusionSecurity = {
  option1?: UpdateRiskExclusionSecurityOption1 | undefined;
  option2?: UpdateRiskExclusionSecurityOption2 | undefined;
};

export type UpdateRiskExclusionRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateRiskExclusionRequestBody: UpdateRiskExclusionRequestBody;
};

/** @internal */
export type UpdateRiskExclusionSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateRiskExclusionSecurityOption1$outboundSchema: z.ZodMiniType<
  UpdateRiskExclusionSecurityOption1$Outbound,
  UpdateRiskExclusionSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function updateRiskExclusionSecurityOption1ToJSON(
  updateRiskExclusionSecurityOption1: UpdateRiskExclusionSecurityOption1,
): string {
  return JSON.stringify(
    UpdateRiskExclusionSecurityOption1$outboundSchema.parse(
      updateRiskExclusionSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateRiskExclusionSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateRiskExclusionSecurityOption2$outboundSchema: z.ZodMiniType<
  UpdateRiskExclusionSecurityOption2$Outbound,
  UpdateRiskExclusionSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateRiskExclusionSecurityOption2ToJSON(
  updateRiskExclusionSecurityOption2: UpdateRiskExclusionSecurityOption2,
): string {
  return JSON.stringify(
    UpdateRiskExclusionSecurityOption2$outboundSchema.parse(
      updateRiskExclusionSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateRiskExclusionSecurity$Outbound = {
  Option1?: UpdateRiskExclusionSecurityOption1$Outbound | undefined;
  Option2?: UpdateRiskExclusionSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateRiskExclusionSecurity$outboundSchema: z.ZodMiniType<
  UpdateRiskExclusionSecurity$Outbound,
  UpdateRiskExclusionSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateRiskExclusionSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateRiskExclusionSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateRiskExclusionSecurityToJSON(
  updateRiskExclusionSecurity: UpdateRiskExclusionSecurity,
): string {
  return JSON.stringify(
    UpdateRiskExclusionSecurity$outboundSchema.parse(
      updateRiskExclusionSecurity,
    ),
  );
}

/** @internal */
export type UpdateRiskExclusionRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateRiskExclusionRequestBody: UpdateRiskExclusionRequestBody$Outbound;
};

/** @internal */
export const UpdateRiskExclusionRequest$outboundSchema: z.ZodMiniType<
  UpdateRiskExclusionRequest$Outbound,
  UpdateRiskExclusionRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateRiskExclusionRequestBody:
      UpdateRiskExclusionRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateRiskExclusionRequestBody: "UpdateRiskExclusionRequestBody",
    });
  }),
);

export function updateRiskExclusionRequestToJSON(
  updateRiskExclusionRequest: UpdateRiskExclusionRequest,
): string {
  return JSON.stringify(
    UpdateRiskExclusionRequest$outboundSchema.parse(updateRiskExclusionRequest),
  );
}
